module.exports = __webpack_public_path__ + "static/media/html-css-javascript.68f22bbb.jpg";